var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3333 9.33333H9.8L9.6 9.13333C10.2667 8.4 10.6667 7.4 10.6667 6.33333C10.6667 3.93333 8.73333 2 6.33333 2C3.93333 2 2 3.93333 2 6.33333C2 8.73333 3.93333 10.6667 6.33333 10.6667C7.4 10.6667 8.4 10.2667 9.13333 9.6L9.33333 9.8V10.3333L12.6667 13.6667L13.6667 12.6667L10.3333 9.33333ZM6.33333 9.33333C4.66667 9.33333 3.33333 8 3.33333 6.33333C3.33333 4.66667 4.66667 3.33333 6.33333 3.33333C8 3.33333 9.33333 4.66667 9.33333 6.33333C9.33333 8 8 9.33333 6.33333 9.33333Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5951_32516",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 12,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3333 9.33333H9.8L9.6 9.13333C10.2667 8.4 10.6667 7.4 10.6667 6.33333C10.6667 3.93333 8.73333 2 6.33333 2C3.93333 2 2 3.93333 2 6.33333C2 8.73333 3.93333 10.6667 6.33333 10.6667C7.4 10.6667 8.4 10.2667 9.13333 9.6L9.33333 9.8V10.3333L12.6667 13.6667L13.6667 12.6667L10.3333 9.33333ZM6.33333 9.33333C4.66667 9.33333 3.33333 8 3.33333 6.33333C3.33333 4.66667 4.66667 3.33333 6.33333 3.33333C8 3.33333 9.33333 4.66667 9.33333 6.33333C9.33333 8 8 9.33333 6.33333 9.33333Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5951_32516)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H16V16H8.67581H0V0Z",
    fill: "#757575"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.856663339b90be9cb92b309acd53a705.svg";
export { ForwardRef as ReactComponent };